import { render, staticRenderFns } from "./ListSettings.vue?vue&type=template&id=31dd29c5&scoped=true&"
import script from "./ListSettings.vue?vue&type=script&lang=js&"
export * from "./ListSettings.vue?vue&type=script&lang=js&"
import style0 from "./ListSettings.vue?vue&type=style&index=0&id=31dd29c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd29c5",
  null
  
)

export default component.exports